---
en:
  om_dashboard:
    active_alarm: Active alarm
    alarm:
      alarm: Alarm
      alarm_category: Alarm category
      alarms_as_of: "{num} {critical} active alarms between {from} and {to}"
      all_active_alarms: All active alarms
      command: Command
      critical: critical
      critical_active_alarms: Critical active alarms
      critical_high_alarm: Critical high alarm
      critical_low_alarm: Critical low alarm
      duration: Duration
      end: End
      energy_losses: Energy losses [MWh]
      high_alarm: High alarm warning
      hydro_component_name: Turbine
      inverter_name: Inverter
      last_update: Last update
      low_alarm: Low alarm warning
      mppt_name: MPPT
      ok: OK
      operational_status: Operational status
      recent_alarms_and_events: Recent alarms and events
      sensor_name: Sensor name
      sensor_type: Sensor type
      setpoint: Setpoint
      solar_component_name: Inverter
      start: Start
      status: Status
      warning: Warning
      wind_component_name: Turbine
    alarm_status:
      environmental: Environmental conditions
      force_majeure: Force majeure
      grid_failure: Grid problem
      inverter_outage: Inverter outage
      manufacturer: Manufacturer alarm
      mppt_outage: MPPT outage
      no_data: No data
      normal_operation: Normal operation
      owner: Stopped by owner
      power_limitation: Power limitation
      snow_coverage: Snow coverage
      still_active: Still active
      stopped_by_owner: Stopped by owner
      string_anomaly: String anomaly
      turbine_ok: Turbine OK
    alarms: Alarms
    alarms_lowcase: alarms
    component_status: Component status
    drilldown:
      accumulated_hours: Accumulated hours of alarms
      accumulated_hours_of_operational_statuses: Accumulated hours per operational status
      active_power: Active power
      alarm_codes: Alarm codes
      alarm_filter: Filter by sensor / keyword
      alarm_frequency_disclaimer: Hours with irradiance above the minimum irradiance threshold defined (default 60 W/m²)
      all_mppts: All MPPTs
      annual_limit: Annual limit
      any: Any
      availability_target: Target
      charts: Charts
      choose_field: Choose field
      choose_mppt: Choose MPPT...
      compare_another: Compare another
      compare_with: Compare with
      compare_with_another: Add another comparison
      compare_with_inverter: Compare {inverter_name} with
      compare_with_turbine: Compare {turbine_name} with
      compared_power_curves: 'Power curve comparison:'
      contractual_availability: Contractual Availability
      critical_alarms: critical alarm status entries
      current: Current
      current_env_flow: Current env. flow req.
      date_summer: Date summer
      date_winter: Date winter
      dc_current_unit: DC Current [A]
      dc_current_unit_normalized: DC Current [%]
      dc_power_unit: DC Power [kW]
      dc_power_unit_normalized: DC Power [%]
      dc_voltage_unit: DC Voltage [V]
      dc_voltage_unit_normalized: DC Voltage [%]
      downtime_hours: Downtime hours
      end_date: End date
      end_time: End time
      energy_based: Energy based availability contract.
      energy_based_availability: Energy-based availability
      energy_losses: Energy losses
      energy_performance_index: Energy Performance Index
      energy_produced: Energy produced
      expected_operating_hours: Expected hours in operation
      export_menu:
        download_csv: Download as CSV
        download_jpg: Download as JPG
        download_pdf: Download as PDF
        download_png: Download as PNG
        download_svg: Download as SVG
        download_xls: Download as XLS
        filenames:
          contractual_availability: contractual_availability
          energy_performance: performance
          energy_production: production
          mppt_heatmap: mppt_heatmap
          mppt_production: mppt_production
          power_curve: power_curve
          production_chart: production_chart
        print_chart: Print chart
        tooltip: Download data
        view_data_table: View datatable
        view_full_screen: View fullscreen
      external_theoretical: Weather model
      fall_loss: Fall loss
      fall_loss_intake: Fall loss intake
      fall_loss_penstock: Fall loss penstock
      filter: Filter
      frequency: Frequency
      full_load_hours: Full load hours
      gen_l1l2: Gen L1L2
      gen_l2l3: Gen L2L3
      gen_l3l1: Gen L3L1
      group_by_category: Group by category
      hours: Hours
      hours_without_alarms: Hours without alarms
      inverter: Inverters
      inverter_production_stats: "{amount} MW as of {timeframe}"
      inverter_single: 'Inverter: {name}'
      key_performance: Key Performance
      key_performance_for: Key Performance for {name}
      last_outage: Last outage was at {date}
      last_week: last 7 days
      level_downstream: Level downstream
      level_upstream: Level upstream
      measured: Measured
      most_frequent_alarms: Most frequent alarms
      most_frequent_alarms_subtitle: Total {number} accumulated hours of alarms between {time_period}
      mppt: MPPTs
      mppt_single: 'MPPT: {name}'
      no_new_outages: No new outages
      no_weather_data: No weather data found
      normalized_power: Normalized power [%]
      normalized_values: Normalized values
      operation: In operation
      operational_status: Operational status
      operational_status_of_inverter: "{name} timeline"
      operational_status_of_mppt: "{name} timeline"
      operational_status_of_mppts: MPPT timelines
      operational_status_per_turbine: Operational status per turbine
      p50_target: P50
      penstock_pressure: Penstock pressure
      performance: Performance
      performance_ratio: Performance Ratio
      performance_subtitle: "{amount}% of performance ratio in {timeframe}"
      potential: Potential
      potential_loss: Potential loss
      power: Power
      power_current_or_voltage: Current, power or voltage
      power_curve: Power curve
      power_curve_for: Power curve for {name}
      power_curve_inv_x_title: Theoretical power
      power_curve_mppt_x_title: Reference power
      power_curve_subtitle: 'Energy losses: {losses} MWh'
      power_curve_unit_solar: kW
      power_curve_unit_wind: MW
      power_curve_x_title: Theoretical power
      power_curve_y_title: Measured power
      power_loss: Power loss
      power_y_title: Power [{unit}]
      production: Production
      production_for_inverter: Production for {name}
      production_in_mw: Production in MW
      production_per_mppt: Production per MPPT for {name}
      production_status_per_inverter: Production status per inverter
      reactive_power: Reactive power
      regulation: Regulation
      remove_comparison: Remove comparison
      set_point: Set point
      set_point_autostart: Set point autostart
      set_point_water_level: Set point water level
      shadow_testing_banner: Shadow testing is active for this plant — production plans are computed but not sent to Kaia Trade.
      show_abnormal: Show only abnormal
      show_all: Show all
      show_only_time_with_active_alarms: Show only time with active alarms
      specific_mppts: Specific MPPT(s)
      start_date: Start date
      start_time: Start time
      start_time_must_be_before_end_time: Start time must be before end time
      start_up_mode: Start up mode
      supervision_power: Supervision power
      temp_outside: Temperature outside
      theoretical: Theoretical
      time_ago: "{duration} ago"
      time_based: Time based availability contract.
      time_based_availability: Time-based availability
      time_scope:
        3m: 3 months
        month: Month
        quarter: Quarter
        week: Week
        year: Year
      time_with_active_alarms: Time with active alarms
      tooltip_hidden: Tooltips disabled due to large data sample
      total_availability: Total energy-based availability
      triggered_at: Triggered at
      turbine: Turbines
      turbine_alarm_loss: "{mw_loss} MWh lost as of {time_period}"
      turbine_power_curve_x_title: Wind speed
      turbine_power_curve_x_unit: m/s
      turbine_power_curve_y_title: Power
      turbine_power_curve_y_unit: MW
      turbine_single: 'Turbine: {name}'
      turbine_timeline: Turbine timeline
      types_of_alarms: Types of alarms
      unavailable: Unavailable
      voltage: Voltage
      water_flow: Water flow
      water_level: Water level
      water_level_downstream: Downstream water level
      weather: Weather
      weather_data: Weather data
      weather_forecast: Weather forecast
      weather_model: Weather model
      wind_production_for: Production in MW for turbines
      wind_rose: Wind rose
      wind_rose_missing: Wind direction data is only available for the previous week. Contact Portal support for more information.
      wind_rose_text: Speeds and directions of selected time period
    duration:
      plural:
        day: "{value} days"
        hour: "{value} hours"
        minute: "{value} minutes"
      short:
        day: "{value}d"
        hour: "{value}h"
        minute: "{value}m"
      singular:
        day: "{value} day"
        hour: "{value} hour"
        minute: "{value} minute"
    env_flow: Environmental flow
    filter: Filter the list
    help:
      alarm_inactive: Alarm active within the last {age}, but now inactive
      alarm_triggered: Alarm triggered in the last {age}
      env_flow_threshold: Environmental flow threshold config missing (power plant form)
      no_alarm: No alarms in the last {age}
      no_live_data: No live data for the last {age}
      sensor_type: Sensor type "{sensor_type}" missing
      upper_alert_limit: Sensor upper_alert_limit not set
    hydro:
      reservoir_status:
        avg_inflow: Average Inflow (24h)
        avg_inflow_tooltip: Expected water inflow rate averaged over the next 24 hours
        below_operational_min: Below operational minimum
        days: "{days} days"
        days_and_hours: "{days} days, {hours} hours"
        days_and_hours_label: "{days} days, {hours} hours"
        days_label: days
        hours: "{hours} hours"
        hours_label: hours
        no_data: No reservoir status data available
        no_inflow: No inflow
        of: of
        operational_energy: Operational Energy
        operational_energy_tooltip: 'Usable energy within the operational limits, based on water level.<br>Operational range: {operational_capacity} MWh, between {op_min_energy} MWh (op min) and {op_max_energy} MWh (op max).<br>Total stored: {absolute_volume} MWh of {full_capacity} MWh theoretical. Outside operational range: {spare_capacity} MWh.'
        production_time: Full Production Time
        production_time_tooltip: How long the plant can run at full capacity ({power} MW) with current reservoir volume and no new inflow
        reservoir_full: Reservoir full
        time_to_fill: Time to Fill
        time_to_fill_tooltip: Time to fill reservoir based on model operational range and average inflow (24h) with no production. May not reach full theoretical capacity if operating within limited range.
        title: Current Reservoir Status
    nest_comm_down: Nest communication down
    operations: Operations
    overflow: Overflow
    overview:
      asset: Asset
      capacity: Capacity
      components: Components
      forecast: Forecast
      forecast_48h: Forecast in 48h
      forecast_now: Weather now
      in_48h: In 48h
      last_update: Last update
      load: Load
      loss: Loss
      losses: Losses
      lost_revenue: Losses {currency_code}/h
      name: Name
      only_revenue: Revenue
      production: Production
      production_stop: Production stop
      revenue: Revenue {currency_code}/h
      status: Status
      title: O&M Overview
    power_plant: Power plant
    power_plant_short: Plant
    power_plant_type:
      magazine: Magazine plant
      run_of_river: Run-of-river
      solar: Solar park
      wind: Wind park
    prod_status:
      outage: Outage
      producing: Producing
      ready: Ready to start
    sensor_mapping:
      clear_search: Clear search
      discard_confirm: You have unsaved changes. Discard them?
      filter_all: All
      filter_mapped: Mapped
      filter_unmapped: Unmapped
      launcher: Sensor configuration
      load_error: Could not load sensors.
      loading: Loading Nest sensors…
      mapped_heading: Mapped ({count})
      no_available_types: No available sensor types
      no_matches: No sensors match your search.
      save_all: Save all
      search: Search by name
      unmapped: Unmapped
      unmapped_heading: Unmapped ({count})
      unsaved_changes: Unsaved changes
    sensor_types:
      chart: Chart
      sidebar: Sidebar
    show_instant_triggers: Show instant triggers
    status:
      hydro:
        low_natural_resource: Low natural resource
        missing_natural_resource: Missing natural resource
        missing_resource: Missing natural resource
        missing_status: Missing status
        no_change: No change
        no_data: No data
        no_energy: No energy
        normal: Normal
        normal_operation: Normal operation
        one_year_ago: one year ago
        outage: Outage
        recent_issue_solved: Recent issue solved
        underperforming: Underperforming
      neutral:
        low_natural_resource: Low natural resource
        missing_natural_resource: Outside operating conditions
        missing_resource: Outside operating conditions
        missing_status: Missing status
        no_change: No change
        no_data: No data
        no_energy: No energy
        normal: Normal
        normal_operation: Normal operation
        one_year_ago: one year ago
        outage: Outage
        recent_issue_solved: Recent issue solved
        underperforming: Underperforming
      solar:
        low_natural_resource: Low irradiance
        missing_natural_resource: Night
        missing_resource: Night
        missing_status: Missing status
        no_change: No change
        no_data: No data
        no_energy: No energy
        normal: Normal
        normal_operation: Normal operation
        one_year_ago: one year ago
        outage: Outage
        recent_issue_solved: Recent issue solved
        resource_above_threshold: Resource above threshold
        resource_below_threshold: Resource below threshold
        underperforming: Underperforming
      wind:
        low_natural_resource: Low wind
        missing_natural_resource: Outside operating conditions
        missing_resource: Outside operating conditions
        missing_status: Missing status
        no_change: No change
        no_data: No data
        no_energy: No energy
        normal: Normal
        normal_operation: Normal operation
        one_year_ago: one year ago
        outage: Outage
        recent_issue_solved: Recent issue solved
        underperforming: Underperforming
    technical: Technical
